var React = require('react');

function Lv (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"#fff","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#981e32","d":"M0 0h640v192H0zm0 288h640v192H0z","key":1})]));
}

Lv.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Lv;

Lv.default = Lv;
